// Hook - unified timeline aktywnosci transakcji
// GET /api/ui/sales-crm/deals/{id}/activities

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetDealActivitiesResponse } from 'api/types/deals';

export type DealActivityFilter =
  | 'NOTE'
  | 'EMAIL'
  | 'MEETING'
  | 'CALL'
  | 'TASK'
  | 'EMAIL_MSG'
  | 'WHATSAPP_MSG'
  | 'ALL';

const getDealActivities = (
  id: number,
  type: DealActivityFilter = 'ALL',
  page = 1,
  limit = 50,
): Promise<IGetDealActivitiesResponse> =>
  axios.get(`/sales-crm/deals/${id}/activities`, { params: { type, page, limit } });

export const useGetDealActivities = (
  id: number,
  type: DealActivityFilter = 'ALL',
  page = 1,
  limit = 50,
  options?: UseQueryOptions<IGetDealActivitiesResponse, IError>,
) =>
  useQuery<IGetDealActivitiesResponse, IError>(
    ['sales-crm-deal-activities', id, type, page, limit],
    () => getDealActivities(id, type, page, limit),
    {
      enabled: id > 0,
      ...options,
    },
  );
